import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'

import { Testable } from '@cred/react-testable'
import { Link as NoAnalyticsLink } from '@cred/react-link'
import { collapsibleClick } from '@cred/react-analytics/events'

import FooterLinks, { Divider } from 'components/footer-links'

import Disclosures from '../../disclosures'
import styles from '../styles.modue.scss'

const MortgageCombinedFooter = ({
  trackSnowplowEvent,
  showDisclosure,
  wrapperClassName,
  linkClassName,
}) => {
  const [isOpen, setOpen] = useState(false)
  const iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclosures',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  return (
    <div className={wrapperClassName}>
      <Testable className={styles.container} testId="footer">
        <FooterLinks
          containerClassName={styles.links}
          dividerClassName="ml-8 mr-8"
          showAdvertiserDisclosure={showDisclosure}
          linkClassName={linkClassName}
        >
          <>
            <Divider className="ml-8 mr-8" />
            <NoAnalyticsLink
              data-for="disclosures"
              className={`${styles.link} ${linkClassName} disclaimer`}
              onClick={toggleLenderList}
            >
              Disclosures <span className={`cred-icon ${iconClass} ${styles.iconStyle}`} />
            </NoAnalyticsLink>
            <Divider className="ml-8 mr-8" />
            <p className={`${linkClassName} disclaimer secondary500`}>
              Credible Operations, Inc. NMLS ID# 1681276
            </p>
          </>
        </FooterLinks>
      </Testable>
      <Collapse isOpened={isOpen}>
        <Disclosures />
      </Collapse>
      <p className="disclaimer">
        We arrange but do not make loans. All loans are subject to underwriting and approval.
        Registered Mortgage Broker - NYS Department of Financial Services. Advertised rates are
        subject to change and may not be available at closing, unless locked with a lender.
      </p>
    </div>
  )
}

MortgageCombinedFooter.propTypes = {
  linkClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  trackSnowplowEvent: PropTypes.func.isRequired,
  showDisclosure: PropTypes.bool.isRequired,
}

export default MortgageCombinedFooter
